import { faWarning } from '@fortawesome/pro-regular-svg-icons';

import { FAIcon } from './fa-icon';

export const WarningIcon = ({ width }: { width?: string }) => (
  <FAIcon icon={faWarning} width={width} />
);
